import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class VentasService {
  
  private service_url: string;
  private serviceFotosUrl: string;

  constructor(private http: Http, 
    private constantsService: ConstantsService, 
    private validatorService: ValidatorService,
    private authService: AutenticacionService, 
    private errorService:ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/ventas';
  }

  public listarVentas(filters: any) {
    let myParams = new URLSearchParams();

    if(filters.page){
      myParams.append('page', filters.page);
    }

    if(filters.id_emisor){
        myParams.append('id_emisor', filters.id_emisor);
    }

    if(filters.id_cliente){
        myParams.append('id_cliente', filters.id_cliente);
    }

    if(filters.fecha_inicio){
        myParams.append('fecha_inicio', filters.fecha_inicio);
    }

    if(filters.fecha_termino){
        myParams.append('fecha_termino', filters.fecha_termino);
    }

    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    return this.http.get(this.service_url, options);
  } 

  public obtenerVenta(venta_id) {

    const options = this.authService.getAuthHeaders();

    return this.http.get(`${this.service_url}/${venta_id}`, options);
  }

  public crear(venta : object) {
    return this.http.post(this.service_url , venta, this.authService.getAuthHeaders());
  }

  public actualizar(venta : object) {
    return this.http.put(this.service_url , venta, this.authService.getAuthHeaders());
  }

  public validar(venta: any, tipo_servicio: string) {
    let error = [];

    if(!this.validatorService.required(venta.id_emisor)){
        error["obra_emisor"] = this.errorService.required;
    }

    if(!this.validatorService.required(venta.id_tipo_servicio)){
        error["tipo_servicio"] = this.errorService.required;
    }

    if(!this.validatorService.required(venta.cliente.rfc)){
        error["cliente_rfc"] = this.errorService.required;
    }

    //Si ya se ha ingresado el RFC entonces se validan los demás campos del cliente
    if(venta.cliente.rfc){

        if(!this.validatorService.required(venta.cliente.nombre)){
            error["cliente_nombre"] = this.errorService.required;
        }

        if(!this.validatorService.required(venta.cliente.direccion)){
            error["cliente_direccion"] = this.errorService.required;
        }

        if(!this.validatorService.required(venta.cliente.email)){
            error["cliente_email"] = this.errorService.required;
        }

        if(!this.validatorService.required(venta.cliente.colonia)){
            error["cliente_colonia"] = this.errorService.required;
        }

        if(this.validatorService.required(venta.cliente.email)){
            var arregloEmails = venta.cliente.email.split(";");
      
            arregloEmails.forEach(email => {
              if(!this.validatorService.email(email.trim())){     
                error['cliente_email'] = "El correo o los correos no tienen un formato valido";
              }
            });
        }else{
            error["cliente_email"] = this.errorService.required;
        }
    }

    if(tipo_servicio ==='HORAS_OFICINA' || tipo_servicio==='EVENTOS'){

        if(tipo_servicio ==='HORAS_OFICINA' && !this.validatorService.required(venta.espacio_trabajo)){
            error["espacio_trabajo"] = this.errorService.required;
        }

        if(!this.validatorService.required(venta.fecha_servicio)){
            error["fecha_servicio"] = this.errorService.required;
        }

        if(!this.validatorService.required(venta.anticipo)){
            error["anticipo"] = this.errorService.required;
        }

        if(!this.validatorService.required(venta.garantia)){
            error["garantia"] = this.errorService.required;
        }
    }

    //Si es una venta periodica se validan los campos complementarios
    if(venta.tiene_periodicidad){
        
        if(!this.validatorService.required(venta.fecha_inicio)){
            error["fecha_inicio"] = this.errorService.required;
        }

        if(!this.validatorService.required(venta.fecha_fin)){
            error["fecha_fin"] = this.errorService.required;
        }

        if(!this.validatorService.required(venta.periodicidad)){
            error["periodicidad"] = this.errorService.required;
        }
    }

    //El error de los productos se debe mostrar solo si ya se selecciono el tipo de servicios
    if(venta.id_tipo_servicio && (!venta.venta_productos || venta.venta_productos.length === 0)){
        error["productos"] = "Selecciona los productos de la venta";
    }

    if((venta.venta_productos && venta.venta_productos.length > 0)){
        venta.venta_productos.forEach(producto => {
            //Se agregar a cada producto, un arreglo para poner los errores
            producto.errores = [];

            if(!this.validatorService.required(producto.concepto_facturar)){
                producto.errores['concepto_facturar'] = this.errorService.required;
                //Agrego el error al arreglo generar de errores, para que sepa que aún hay información por arreglar
                error["concepto_facturar"] = this.errorService.required;
            }
        });
    }

    return error;
  }


}


// WEBPACK FOOTER //
// ./src/app/services/ventas.service.ts